import { render, staticRenderFns } from "./genreTracks.vue?vue&type=template&id=7771c964&scoped=true&"
import script from "./genreTracks.vue?vue&type=script&lang=ts&"
export * from "./genreTracks.vue?vue&type=script&lang=ts&"
import style0 from "./genreTracks.vue?vue&type=style&index=0&id=7771c964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7771c964",
  null
  
)

export default component.exports